export enum TASK_PRIORITY {
  NONE = 'None',
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
}
